@if (!loading) {
  <div>
    @if (creationError) {
      <p class="alert alert-danger" role="alert">{{ creationError }}</p>
    }
    <div class="container-fluid border rounded bg-light">
      <form (ngSubmit)="generate()" class="d-flex flex-row flex-wrap align-items-center p-1">
        <ng-template #defaultNewReportOptionsTemplate />
        <ng-template
          [ngTemplateOutlet]="newReportOptionsTemplate || defaultNewReportOptionsTemplate"
          [ngTemplateOutletContext]="{ filtersForm: filtersForm, outputOptionsForm: outputOptionsForm }" />
        <div class="col-auto">
          <button class="btn btn-primary m-1" type="submit" [disabled]="!newReportOptionsValid || generating">
            <span [hidden]="generating">Generate Report</span>
            <span [hidden]="!generating">
              <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" /> Generating Report
            </span>
          </button>
        </div>
      </form>
      @if (formMessage) {
        <div class="flex-row px-2 pb-1">
          <div class="col-auto small">
            {{ formMessage }}
          </div>
        </div>
      }
    </div>
    @if (reports.length > 0) {
      <section>
        <h3>{{ title || 'Reports' }}</h3>
        <app-pagination-header [paging]="paging" [label]="'reports'" (pageSizeChange)="onPageSizeChange($event)" />
        <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
        <table class="table table-bordered table-hover">
          <thead>
            <tr>
              <th>ID</th>
              <th>User</th>
              <th>Started</th>
              <th>Duration</th>
              <th>Status</th>
              <th>{{ totalColumnHeader }}</th>
              @if (displayProcessedColumn) {
                <th>Processed</th>
              }
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (report of reports; track report) {
              <tr class="row-primary">
                <td>{{ report.id }}</td>
                <td>{{ report.username }}</td>
                <td>{{ report.startedAt | date: 'M/d/yyyy hh:mm a' }}</td>
                <td>{{ report.elapsedWords }}</td>
                <td>{{ report.status | titlecase }}</td>
                <td>{{ report.totalRows | number: '' }}</td>
                @if (displayProcessedColumn) {
                  <td>{{ report.processedRows | number: '' }}</td>
                }
                <td>
                  <button class="btn btn-primary" [disabled]="report.status !== 'completed'" (click)="download(report)">
                    Download
                  </button>
                  @if (isProcessing(report)) {
                    <button class="btn btn-secondary" (click)="cancel(report)">Cancel</button>
                  }
                </td>
              </tr>
              @if (forceReportDetailsDisplay || hasAppliedOptions(report)) {
                <tr class="row-secondary">
                  <td colspan="8">
                    <ng-template #defaultReportDetailsTemplate />
                    <ng-template
                      [ngTemplateOutlet]="reportDetailsTemplate || defaultReportDetailsTemplate"
                      [ngTemplateOutletContext]="{ report: report }" />
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </section>
    } @else {
      <section>
        <p>
          Click 'Generate Report' to create a new
          @if (availableRecordCount) {
            report with <strong>{{ availableRecordCount | number: '' }}</strong> rows.
          }
          @if (!availableRecordCount) {
            report.
          }
        </p>
      </section>
    }
  </div>
} @else {
  <mat-spinner />
}
